/* VOCLA opt-in, user-controlled looping multicolumn carousel. */
(() => {
  function start(root) {
    root.querySelectorAll('[data-vocla-carousel]').forEach(carousel => {
      if (carousel.dataset.voclaReady === 'true') return;
      const track = carousel.querySelector('.vocla-carousel__track');
      const originals = Array.from(track.children);
      if (originals.length < 2) return;
      carousel.dataset.voclaReady = 'true';

      function clone(item) {
        const copy = item.cloneNode(true);
        copy.removeAttribute('id');
        copy.removeAttribute('data-shopify-editor-block');
        copy.removeAttribute('data-shopify-editor-block-id');
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        // Theme scroll-reveal observers do not automatically register cloned cards.
        [copy, ...copy.querySelectorAll('.scroll-trigger')].forEach(node => {
          node.classList.remove('scroll-trigger', 'animate--slide-in');
          node.removeAttribute('data-cascade');
          node.style.removeProperty('--animation-order');
        });
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
        return copy;
      }
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      originals.forEach(item => { before.appendChild(clone(item)); after.appendChild(clone(item)); });
      track.prepend(before);
      track.append(after);

      function stride() {
        const items = track.children;
        return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
      }
      function span() { return stride() * originals.length; }
      function recenter() {
        const width = span();
        if (!width) return;
        if (track.scrollLeft < width - 1) track.scrollLeft += width;
        else if (track.scrollLeft >= width * 2 - 1) track.scrollLeft -= width;
      }
      // Begin on the real cards, with one complete copy on either side.
      track.scrollLeft = span();
      let scrollEndTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(recenter, 160);
      }, { passive: true });

      function move(direction) {
        const step = stride();
        if (!step) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.scrollLeft += step * direction;
          recenter();
        } else {
          track.scrollBy({ left: step * direction, behavior: 'smooth' });
        }
      }
      carousel.querySelector('[data-vocla-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-vocla-next]')?.addEventListener('click', () => move(1));

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const oldStep = stride();
          const current = oldStep ? Math.round(track.scrollLeft / oldStep) % originals.length : 0;
          track.scrollLeft = span() + current * stride();
        }, 160);
      });
    });
  }
  function init() { start(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
